export const SOAP_KEYS = [
  { key: "subjective", letter: "S", label: "Subjective", hint: "Caregiver / staff reports, client presentation" },
  { key: "objective", letter: "O", label: "Objective", hint: "Interventions, trial data, behavior data" },
  { key: "assessment", letter: "A", label: "Assessment", hint: "Progress toward goals, medical necessity" },
  { key: "plan", letter: "P", label: "Plan", hint: "Next session, programming changes" },
];

export const POLISH_PRESETS = [
  { key: "clinical", label: "Refine clinical tone" },
  { key: "objective", label: "Make language objective & measurable" },
  { key: "necessity", label: "Strengthen medical necessity" },
  { key: "shorten", label: "Shorten for payer audit" },
  { key: "grammar", label: "Fix grammar & spelling only" },
];

export const SETTINGS = ["Clinic", "Home", "School", "Community", "Telehealth"];
export const CPT_CODES = [
  { code: "97151", label: "97151 · Behavior identification assessment" },
  { code: "97153", label: "97153 · Adaptive behavior treatment by protocol" },
  { code: "97155", label: "97155 · Treatment w/ protocol modification" },
  { code: "97156", label: "97156 · Family / caregiver guidance" },
  { code: "97158", label: "97158 · Group treatment w/ modification" },
];
export const PROMPT_LEVELS = ["Independent", "Gestural", "Verbal", "Model", "Partial physical", "Full physical"];
export const DOMAINS = ["Communication", "Listener", "Social", "Play", "Daily living", "Academic", "Motor", "Behavior reduction"];

export function parseSections(text) {
  const out = { subjective: "", objective: "", assessment: "", plan: "" };
  const re = /#{2,3}\s*(SUBJECTIVE|OBJECTIVE|ASSESSMENT|PLAN)\s*:?/gi;
  const marks = [];
  let m;
  while ((m = re.exec(text))) marks.push({ key: m[1].toLowerCase(), start: m.index, end: re.lastIndex });
  marks.forEach((mk, i) => {
    out[mk.key] = text.slice(mk.end, i + 1 < marks.length ? marks[i + 1].start : text.length).trim();
  });
  return out;
}

export function fmt12(v) {
  if (!v || !/^\d{1,2}:\d{2}$/.test(v)) return v || "";
  const [H, M] = v.split(":").map(Number);
  return `${H % 12 || 12}:${String(M).padStart(2, "0")} ${H >= 12 ? "PM" : "AM"}`;
}

export function notePlainText(n) {
  return SOAP_KEYS.map((s) => `${s.label.toUpperCase()}\n${n[s.key] || ""}`).join("\n\n");
}

export function noteFullText(n, template) {
  const out = [];
  const meta = [
    ["Client", n.client_name],
    ["Date", n.session_date],
    ["Time", n.start_time && `${fmt12(n.start_time)} - ${fmt12(n.end_time)}`],
    ["Setting", n.setting],
    ["CPT code", n.cpt_code],
    ["Provider", n.provider_name && `${n.provider_name}, ${n.provider_role}`],
  ].filter(([, v]) => v);
  meta.forEach(([k, v]) => out.push(`${k}: ${v}`));
  if (template) {
    const rows = template.fields.filter((f) => n.template_fields?.[f.key]);
    if (rows.length) out.push("", template.name.toUpperCase(), ...rows.map((f) => `${f.label}: ${n.template_fields[f.key]}`));
  }
  const targets = (n.targets || []).filter((t) => t.name && t.total);
  if (targets.length) out.push("", "SKILL ACQUISITION DATA", ...targets.map((t) => `- ${t.name}: ${t.correct}/${t.total} (${pct(t.correct, t.total)}%)${t.prompt_level ? `, ${t.prompt_level}` : ""}`));
  const behaviors = (n.behaviors || []).filter((b) => b.name);
  if (behaviors.length) out.push("", "BEHAVIOR DATA", ...behaviors.map((b) => `- ${b.name}: frequency ${b.frequency}${b.duration ? `, duration ${b.duration}` : ""}${b.notes ? `, ${b.notes}` : ""}`));
  out.push("", notePlainText(n));
  return out.join("\n").trim();
}

export const pct = (c, t) => (t ? Math.round((100 * c) / t) : 0);

export function emptyNote() {
  return {
    client_id: null,
    client_name: "",
    session_date: new Date().toISOString().slice(0, 10),
    start_time: "",
    end_time: "",
    setting: "Clinic",
    cpt_code: "97153",
    targets: [],
    behaviors: [],
    session_details: "",
    template_fields: {},
    subjective: "",
    objective: "",
    assessment: "",
    plan: "",
    status: "draft",
  };
}
